import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'nutrition',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'patient-nutrition-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                   
                    {                           
                        transKey: 'breadcrumbs.nutrition-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "index-habits" */ '@/modules/patient-profile/nutrition/views/Create.vue')
        }
    ]
}